var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('sidebar.shortTitle'),"title":"代下助手后台"}},[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: '主页',
          icon: 'tim-icons icon-bullet-list-67',
          path: '/home',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: '套餐管理',
          icon: 'tim-icons icon-bag-16',
          path: '/package',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: '网站设置',
          icon: 'tim-icons icon-settings-gear-63',
          path: '/settings',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: '网站管理',
          icon: 'tim-icons icon-atom',
          path: '/site',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: '用户管理',
          icon: 'tim-icons icon-single-02',
          path: '/user',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: '卡密管理',
          icon: 'tim-icons icon-map-big',
          path: '/cdk',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: '下载记录',
          icon: 'tim-icons icon-cloud-download-93',
          path: '/record',
        }}})],1)],2),_c('sidebar-share',{attrs:{"background-color":_vm.sidebarBackground},on:{"update:backgroundColor":function($event){_vm.sidebarBackground=$event},"update:background-color":function($event){_vm.sidebarBackground=$event}}}),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }